
@if (customSellerInfo) {
  <div class="mb-3">
    <div>
      <h2 class="pb-2 border-bottom" i18n>Anbieterinformationen</h2>
      @if (!showEdit) {
        <div class="mb-2">
          @if (imageFile) {
            <div class="card">
              <img [src]="imageFile" class="card-img-top" alt="" />
              <div class="card-body">
                <div class="example-config" [innerHTML]="customSellerInfo?.brandInfoText"></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    @if (customSellerInfo?.id) {
      <div>
        <div>
          @if (!customSellerInfo?.id && !showEdit) {
            <div>
              <div class="mt-2">
                <p i18n>
            Ihre Standardanbieterinformationen werden angezeigt. Sie können Informationen zu Ihrem
            Anbieterprofil ergänzen.
          </p>
              </div>
            </div>
          }
          <div class="mt-2">
            @if (!showEdit) {
              <button class="btn btn-primary mt-2 mb-2" (click)="toggleEdit()" i18n>
          Anbieterinfo bearbeiten
        </button>
            }
          </div>
          @if (showEdit) {
            <div>
              <form [formGroup]="myForm">
                <div class="row justify-content-end">
                  <div class="col-sm-3">
                    <button class="btn btn-sm btn-success me-2 mb-2" type="button" [asyncClick]="save.bind(this)" [disabled]="saveBtn.disabled" #saveBtn="asyncClick" i18n>
                @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
                Speichern
              </button>
                    <button class="btn btn-sm btn-danger mb-2" (click)="cancelEdit()" i18n>
                Abbrechen
              </button>
                  </div>
                </div>
                <div>
                  <div class="row mt-4 mb-2">
                    <div class="row">
                      <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Anbieterbild</label>
                    </div>
                    <div class="row">
                      <small class="text-muted" i18n>
                  <p>Dieses Bild wird auf der Anbieterseite angezeigt.</p>
                </small>
                    </div>
                    <div class="row m-1">
                      <img [src]="imageFile" class="img-fluid col-sm-3" alt="" />
                    </div>
                    <div class="row">
                      <div class="col-sm-10">
                        <kendo-fileselect
                          formControlName="files"
                          [multiple]="false"
                          (select)="selectImageEventHandler($event)"
                          >
                          <!-- todo: localization -->
                      </kendo-fileselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="example-wrapper">
                <kendo-editor formControlName="editor" style="height: 400px">
                  <kendo-toolbar>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-dropdownlist
                    kendoEditorFormat
                  ></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                  <kendo-toolbar-colorpicker
                    kendoEditorBackColor
                    view="gradient"
                  ></kendo-toolbar-colorpicker>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
            </kendo-toolbar>
          </kendo-editor>
        </div>
      </form>
    </div>
  }
</div>
</div>
}
</div>
}
